import ApiClientInstance from '../../common/ApiClient';
import { ISO_DATE_FORMAT } from '../../utils/formatters';

export const apiRequestZip = (companyId, accountId, { start, end }) => (
  ApiClientInstance.post(
    `api/accountants/company/transactions/${accountId}/zip?date_start=${start.format(ISO_DATE_FORMAT)}&date_end=${end.format(ISO_DATE_FORMAT)}${companyId ? `&company_id=${companyId}` : ''}`,
  )
);

export const apiRequestZipCheckStatus = (companyId, accountId, taskId) => (
  ApiClientInstance.get(
    `api/accountants/company/transactions/${accountId}/zip/${taskId}${companyId ? `?company_id=${companyId}` : ''}`,
  )
);

export const apiGetZip = (companyId, id) => ApiClientInstance.get(
  `api/accountants/company/media/${id}${companyId ? `?company_id=${companyId}` : ''}`,
  {
    'Content-Type': 'application/zip',
  },
);

export const apiGetFile = (url) => ApiClientInstance.get(url);
